// extracted by mini-css-extract-plugin
export var container = "navbar-module--container--WSrYO";
export var heading = "navbar-module--heading--YLLII";
export var navLinks = "navbar-module--nav-links--+CChw";
export var navLinkItem = "navbar-module--nav-link-item--p4meV";
export var navLinkText = "navbar-module--nav-link-text--W-vc7";